export const ColorMap = {
	azul: { name: "Azul", hex: "#2C5DF7" },
	"azul-topázio": { name: "Azul Topázio", hex: "#1e304d" },
	"azul-titã": { name: "Azul Titã", hex: "#1e304d" },
	"azul-tita": { name: "Azul Titã", hex: "#1e304d" },
	"branco-cinza": { name: "Branco Cinza", hex: "#c8c8c8" },
	"branco-lunar": { name: "Branco Lunar", hex: "#e3e3e3" },
	"branco-lunar-e-preto-attitude": {
		name: "Branco Lunar e Preto Attitude",
		hex:  "#e3e3e3",
	},
	"branco-polar": { name: "Branco Polar", hex: "#FCFCFC" },
	"branco-pérola": { name: "Branco Pérola", hex: "#fff9eb" },
	"branco-perola": { name: "Branco Pérola", hex: "#fff9eb" },
	"branco-sólido": { name: "Branco Sólido", hex: "#FFFFFF" },
	"branco-solido": { name: "Branco Sólido", hex: "#FFFFFF" },
	cinza: { name: "Cinza", hex: "#808080" },
	"cinza-celestial": { name: "Cinza Celestial", hex: "#5f6878" },
	"cinza-titan": { name: "Cinza Titan", hex: "#768293" },
	"cinza-granito": { name: "Cinza Granito", hex: "#2b2b2b" },
	"imperial-aureum": { name: "Imperial Aureum", hex: "#C9C0B7" },
	prata: { name: "Prata", hex: "#ACADAC" },
	"prata-supernova": { name: "Prata Supernova", hex: "#b5b5b5" },
	"prata-lua-nova": { name: "Prata Lua Nova", hex: "#b5b5b5" },
	"prata-névoa": { name: "Prata Nevoa", hex: "#b5b5b5" },
	preto: { name: "Preto", hex: "#363636" },
	"preto-eclipse": { name: "Preto Eclipse", hex: "#000000" },
	"preto-infinito": { name: "Preto Infinito", hex: "#000000" },
	"preto-attitude": { name: "Preto Attitude", hex: "#000000" },
	"preto-atitude": { name: "Preto Atitude", hex: "#1B1B1B" },
	vermelho: { name: "Vermelho", hex: "#CD383E" },
	"vermelho-granada": { name: "Vermelho Granada", hex: "#870000" },
	"vermelho-volcano": { name: "Vermelho Volcano", hex: "#8c0606" },
	"vermelho-volcano-e-preto-attitude": {
		name: "Vermelho Volcano e Preto Attitude",
		hex: "#8c0606",
	},
	"vermelho-emoção": { name: "Vermelho Emoção", hex: "#870000" },
	"vermelho-emocao": { name: "Vermelho Emoção", hex: "#870000" },
	"marrom-urban": { name: "Marrom Urban", hex: "#0d0501" },
} as const;

export type ColorMapKey = keyof typeof ColorMap;
export type ColorMapType = typeof ColorMap;
